import React, { useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";

import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect,
  BrowserRouter,
} from "react-router-dom";
import { ScrollContext } from "react-router-scroll-4";
// ** Import custom components for redux**
import { Provider } from "react-redux";
import indexStore from "./store/index";
import store from "store";
import AppIndex from "./containers/app/index";
import { ToggleProvider } from "./context/contextProvider";
//firebase Auth
function NextApp() {
  const abortController = new window.AbortController();
  useEffect(() => {
    const themeColor = localStorage.getItem("theme-color");
    const layout = localStorage.getItem("layout_version");
    document
      .getElementById("color")
      .setAttribute(
        "href",
        `${process.env.PUBLIC_URL}/assets/css/${themeColor}.css`
      );
    document.body.classList.add(layout);

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  // store.get("authToken");
  document.addEventListener("login", function (e) {
    //console.log({ e }); // Prints "Example of an event"
  });
  //console.log("authToken", store.get("authToken"));

  return (
    <div className="App">
      <Provider store={indexStore}>
        <ToggleProvider>
          <Router basename={`/`}>
            <ScrollContext>
              <Switch>
                <Route path="/" component={AppIndex} />
              </Switch>
            </ScrollContext>
          </Router>
        </ToggleProvider>
      </Provider>
    </div>
  );
}

export default NextApp;
